<section class="favie-auto-complete__section">
  <mat-form-field appearance="fill">
    <mat-label *ngIf="field?.label">{{ field?.label }}</mat-label>

    <input
      matInput
      type="search"
      class="flex--1"
      [matAutocomplete]="auto"
      [formControl]="control"
      [required]="field?.required"
      [placeholder]="field?.placeholder"
      [class.p__r--16]="field?.icon"
      (blur)="onBlur($event)"
    />

    <mat-icon *ngIf="field?.icon">{{ field?.icon }}</mat-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="selectOption($event)"
      (closed)="closeDropdown()"
    >
      <ng-container *ngIf="field?.options?.length">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [ngStyle]="{'height': scrollViewPortHeight}"
          itemSize="30"
        >
          <mat-option
            *cdkVirtualFor="let option of field.options"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </ng-container>
    </mat-autocomplete>

    <mat-error *ngIf="control?.touched && control?.invalid">
      {{ control?.errors | inputError | translate }}
    </mat-error>
  </mat-form-field>
</section>
